import { withChartLayout } from 'components/common';
import SafetyInterventions from 'components/features/chart/system-nursing-interventions/safety-interventions/SafetyInterventions';

const SafetyInterventionsPage = withChartLayout('Safety Interventions')(SafetyInterventions);
export default SafetyInterventionsPage;
